import { HttpService } from "../../modules/shared/services/http.service";
import { 
  AdminGeneralSettings, 
  AdminGeneralSettingsCreateDto, 
  AdminGeneralSettingsUpdateDto,
  AdminGeneralSettingsResponse,
  AdminGeneralSettingsLatestResponse
} from "../../modules/shared/model";

const headers = { "Content-Type": "application/json", "x-custom-lang": "en" } as const;

// Get latest admin general settings
export const getLatestAdminGeneralSettings = async (): Promise<AdminGeneralSettingsLatestResponse> => {
  const response = await HttpService.get("api/v1/admin-general-settings/latest", true, { "x-custom-lang": "en" });
  return response;
};

// Get all admin general settings with pagination
export const getAdminGeneralSettings = async (query?: Record<string, string | number | boolean>): Promise<AdminGeneralSettingsResponse> => {
  const qs = new URLSearchParams();
  Object.entries(query || {}).forEach(([k, v]) => {
    if (v !== undefined && v !== null) qs.append(k, String(v));
  });
  const response = await HttpService.get(`api/v1/admin-general-settings${qs.toString() ? `?${qs}` : ""}`, true, { "x-custom-lang": "en" });
  return response;
};

// Get admin general settings by ID
export const getAdminGeneralSettingsById = async (id: string): Promise<AdminGeneralSettings> => {
  const response = await HttpService.get(`api/v1/admin-general-settings/${id}`, true, { "x-custom-lang": "en" });
  return response;
};

// Create new admin general settings
export const createAdminGeneralSettings = async (data: AdminGeneralSettingsCreateDto): Promise<AdminGeneralSettings> => {
  const response = await HttpService.post("api/v1/admin-general-settings", data, headers, true);
  return response;
};

// Update admin general settings
export const updateAdminGeneralSettings = async (id: string, data: AdminGeneralSettingsUpdateDto): Promise<AdminGeneralSettings> => {
  const response = await HttpService.patch(`api/v1/admin-general-settings/${id}`, data, headers, true);
  return response;
};

// Delete admin general settings
export const deleteAdminGeneralSettings = async (id: string): Promise<void> => {
  await HttpService.deleteRecord(`api/v1/admin-general-settings/${id}`, { "x-custom-lang": "en" }, true);
};

